import configService from './app-config.service';

const getAll = async (authToken) => {
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${authToken}`);

    const options = {
        method: 'GET',
        headers: headers
    };

    const response = await fetch(`${configService.appConfig.apiUrl}/country/getAll`, options);

    if (!response.ok) {
        const message = `An error occurred: ${response.statusText}`;
        console.error(message);
        return;
    }

    const jsonData = await response.json();
    return jsonData;
};

const getById = async (authToken, id) => {
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${authToken}`);

    const options = {
        method: 'GET',
        headers: headers
    };

    const response = await fetch(`${configService.appConfig.apiUrl}/country/id/${id}`, options);

    if (!response.ok) {
        const message = `An error occurred: ${response.statusText}`;
        console.error(message);
        return;
    }

    const jsonData = await response.json();
    return jsonData;
};

const getAllFuels = async (authToken) => {
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${authToken}`);

    const options = {
        method: 'GET',
        headers: headers
    };

    const response = await fetch(`${configService.appConfig.apiUrl}/country/GetAll/Fuels`, options);

    if (!response.ok) {
        const message = `An error occurred: ${response.statusText}`;
        console.error(message);
        return;
    }

    const jsonData = await response.json();
    return jsonData;
};

export default {
    getAll,
    getAllFuels,
    getById
};
